export default {
  nav: 70,
  contentWidth: 996
}



// WEBPACK FOOTER //
// ./src/styles/dims.js